import { render, staticRenderFns } from "./userCountry.vue?vue&type=template&id=bbefa4f8"
import script from "./userCountry.vue?vue&type=script&lang=js"
export * from "./userCountry.vue?vue&type=script&lang=js"
import style0 from "./userCountry.vue?vue&type=style&index=0&id=bbefa4f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports